module.exports = __webpack_public_path__ + "img/sent-email.3532f282.svg";